import { Entity } from "./Entity";
import { Container } from "../HTML/Container/Container";
import type { App } from "./App";
import type { HANavigationApp } from "./HANavigationApp";

export class AppManager extends Entity {

    public reloadNav(nav: HANavigationApp) {
        const qMenu = nav.getQMenu();
        if (qMenu && qMenu.size > 0) {
            this.setSubscribersData("qmenu", qMenu);
            this.notifySubscribers("qmenu");
        }
    }

    public update(app: App) {
        if (this.getApp()) {
            this.getApp().outro();
        }
        this.addToData("app", app);
        this.getAppContainer().replaceByTag(app.getTag());
        const appInfo = app.getInfo();
        if (appInfo) {
            this.setSubscribersData("appInfo", appInfo);
            this.notifySubscribers("appInfo");
        }
        const qMenu = app.getQMenu();

        if (qMenu && qMenu.size > 0) {
            this.setSubscribersData("qmenu", qMenu);
            this.notifySubscribers("qmenu");
        }
        app.intro();
    }

    protected getApp(): App {
        return this.get("app");
    }

    protected setApp(app: App) {
        this.addToData("app", app);
    }

    public subscribe(type: string, func: (d: any) => void) {
        const s: Map<any, any> = this.getSubscribers(type);
        if (s) {
            const key = (this.get("_subCount_" + type) || 0) + 1;
            this.addToData("_subCount_" + type, key);
            s.set(key, func);
            func(this.getSubscribersData(type));
        }
    }

    protected getSubscribers(type: string) {
        const subs: Map<string, any> = this.get("subscribers");
        return subs.get(type);
    }

    protected setSubscribersData(type: string, data: any) {
        const subsData: Map<string, any> = this.get("subscribersData");
        subsData.set(type, data);
    }

    protected getSubscribersData(type: string) {
        const subsData: Map<string, any> = this.get("subscribersData");
        return subsData.get(type);
    }

    protected notifySubscribers(type: string) {
        const s: Map<any, any> = this.getSubscribers(type);
        if (s) {
            s.forEach((func) => {
                func(this.getSubscribersData(type));
            });
        }
    }

    protected getAppContainer() {
        return this.get("appContainer");
    }

    protected initialize(data: any) {
        super.initialize(data);
        const appCont = new Container(data);
        this.addToData("appContainer", appCont);
        this.initSubscribers();
    }

    protected initSubscribers() {
        const s = new Map();
        const sd = new Map();
        s.set("appInfo", new Map());
        sd.set("appInfo", new Map());
        s.set("qmenu", new Map());
        sd.set("qmenu", new Map());
        this.addToData("subscribers", s);
        this.addToData("subscribersData", sd);
    }
}
